import { computed, signal } from '@preact/signals';

/** Tiny history-API router. Tab screens live at /, /now, /calendar, /more;
 *  everything else is a sub-screen pushed on top (back returns to its tab). */

export type Tab = 'chat' | 'now' | 'calendar' | 'more';

export const path = signal(location.pathname + location.search);

export const route = computed(() => parse(path.value));

export interface Route {
  name: string;
  tab: Tab | null;
  params: Record<string, string>;
  query: URLSearchParams;
}

const TAB_PATHS: Record<string, Tab> = { '/': 'chat', '/now': 'now', '/calendar': 'calendar', '/more': 'more' };

function parse(full: string): Route {
  const qIndex = full.indexOf('?');
  const p = qIndex === -1 ? full : full.slice(0, qIndex);
  const query = new URLSearchParams(qIndex === -1 ? '' : full.slice(qIndex));
  const tab = TAB_PATHS[p];
  if (tab) return { name: tab, tab, params: {}, query };

  let m: RegExpMatchArray | null;
  if ((m = p.match(/^\/roster\/new$/))) return { name: 'add-animal', tab: 'more', params: {}, query };
  if ((m = p.match(/^\/roster\/([^/]+)$/))) return { name: 'roster-detail', tab: 'more', params: { id: m[1] }, query };
  if (p === '/roster') return { name: 'roster', tab: 'more', params: {}, query };
  if ((m = p.match(/^\/calendar\/([^/]+)$/))) return { name: 'calendar-event', tab: 'calendar', params: { id: m[1] }, query };
  if (p === '/photos') return { name: 'photos', tab: 'more', params: {}, query };
  if ((m = p.match(/^\/reports\/([^/]+)$/))) return { name: 'report-output', tab: 'more', params: { id: m[1] }, query };
  if (p === '/reports') return { name: 'reports', tab: 'more', params: {}, query };
  if (p === '/history') return { name: 'history', tab: 'chat', params: {}, query };
  if (p === '/settings') return { name: 'settings', tab: 'more', params: {}, query };
  if (p === '/onboarding') return { name: 'onboarding', tab: null, params: {}, query };
  if (p === '/signin') return { name: 'signin', tab: null, params: {}, query };
  return { name: 'chat', tab: 'chat', params: {}, query };
}

export function navigate(to: string, replace = false) {
  if (to === path.value) return;
  if (replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  path.value = to;
}

export function back(fallback = '/') {
  if (history.length > 1) history.back();
  else navigate(fallback, true);
}

window.addEventListener('popstate', () => {
  path.value = location.pathname + location.search;
});
